<template>
  <div >
    <div v-if="!next" class="center">
      <!--SEARCH-->
      <b-container class="text-center">
        <luma-search-domain></luma-search-domain>
      </b-container>
      <hr>
      <b-container class="mb-4">
          <luma-order-domain></luma-order-domain>
      </b-container>
      <hr>
      <!--USERCONFIG-->
      <b-container >
      <domain-setup-view  :save_button="false"
                          @emit_all_config="emit_all_config"></domain-setup-view>
      </b-container>
      <!--RESULTS-->
      <!--TABLE-->
      <b-container >
            <luma-table></luma-table>
      </b-container>
      <br>
      <br>
      <br>
      <br>
    </div>

    <luma-button-wrapper v-if="success.list.includes(false)">
      <template v-slot:button>
        <b-button v-if="!next" class="col-12" @click="next = !next"><h3>Weiter zur Bestellung</h3></b-button>
        <b-button v-if="next" class="col-12" variant="primary" @click="createDomain()"><h3>Sofort bestellen</h3></b-button>
      </template>
    </luma-button-wrapper>

<!--    <b-row class="mb-4 fixed-bottom footer-summary" v-if="success.list.includes(false)" >-->
<!--      <b-col>-->
<!--        <b-button v-if="!next" class="col-12" @click="next = !next"><h3>Weiter zur Bestellung</h3></b-button>-->
<!--        <b-button v-if="next" class="col-12" variant="primary" @click="createDomain()"><h3>Sofort bestellen</h3></b-button>-->
<!--      </b-col>-->
<!--    </b-row>-->

    <!--ORDER-->
    <b-container   v-if="next">
      <b-container class="text-center" >
        <h1>Bestellung</h1>
      </b-container>
      <hr>
      <b-container class="text-center">
          <b-container class="text-center">
            <luma-order-domain></luma-order-domain>
          </b-container >
          <b-container class="text-center">
              <div class="m-2"><b-link  @click="next = !next"><h3>Zurück zur Suche</h3></b-link></div>
          </b-container>
      </b-container>
      <hr>
       <br>
      <br>
      <br>
      <br>
      <br>
    </b-container>
  </div>
</template>

<script>
  import {Domain} from "@/store/models/domain/domain";
  import LumaTable from "./LumaTable";
  import {DomainSearchResult} from "@/store/models/layout/domain_search_result";
  import LumaOrderDomain from "./luma-order-domains";
  import LumaOrderNsHdSettingsDomain from "./luma-order-ns-hd-settings-domain";
  import DomainNameserver from "@/store/models/domain/domain_nameserver";
  import LumaSearchDomain from "./luma-search-domain";
  import UserConfigDefaults from "@/store/models/layout/user_config";
  import LumaDomainHandlesSelection from "../setup_domain/luma-domain-handles-selection";
  import LumaDomainNameserverSelection from "../setup_domain/luma-domain-nameserver-selection";
  import DomainSetupView from "../setup_domain/domain-setup-view";
  import LumaSaveChangesButton from "../../layout/luma-save-changes-button";
  import LumaButtonWrapper from "../../layout/luma-button-wrapper";

  export default {
    name:'luma-create-domain',
    components:{
        LumaButtonWrapper,
        LumaSaveChangesButton,
        DomainSetupView,
        LumaDomainNameserverSelection,
        LumaDomainHandlesSelection, LumaSearchDomain, LumaOrderNsHdSettingsDomain, LumaOrderDomain, LumaTable},
    data:()=>({
      domain_configuration:{},
      next:false,
      localChange:false
    }),

    computed:{
      success(){
        const x = {}
        const y = []
        this.domainC.map(el=>{
          x[el.name]=el.success
          y.push(el.success)
        })
        return {dict:x,list:y}
      },
      domainC(){
        return DomainSearchResult.all()
      },
      user(){
        return this.$currentUser.$id
      }
    },
    methods:{
        emit_all_config(data){
            this.domain_configuration = Object.assign({},this.domain_configuration,data)
        },
        emit_local_change(){
            this.localChange = true
        },
      get_config(val){
        console.log('recieved :::',val)
        this.domain_configuration = Object.assign({},val)
      },
      async createDomain(){

        const x = await this.domainC.map((el,key)=> {
          //DomainSearchResult.update({where:this.domainC[el.name].$id,data:this.domainC[el.name]})
          DomainSearchResult.update({where: el.name, data: {...el}})
          // IF SUCCESS
          if (!el.success) {

            DomainSearchResult.update({where: el.name, data: {spinner: true}})

            const config = Object.assign({}, this.domain_configuration)
            const nn = DomainNameserver.nameserverKeys.map(item => {
              console.log('DELETE errUSERCONFIG ITEM:::')
              //this.userconfig[key][item] ? console.log('DELETE error USERCONFIG ITEM:::',this.userconfig[key][item]) : console.log('DELETE error USERCONFIG ITEM:::',this.userconfig) //delete this.userconfig[item]
              const cc = config[item] === 'option' || config[item] === null ? delete config[item] : ''
              console.log('DELETE errUSERCONFIG confITEM:::', config)
            })

            Domain.createDomain({domainName: el.name, create_zone: true, ...config}).then(
              (response) => {
                const d = {
                  where: el.name,
                  data: {
                    spinner: false,
                    success: true
                  }
                }

                DomainSearchResult.update({...d})
                console.log('CREATE RESPONSE:::', response)
              }
            ).catch((error) => {

              const d = {
                where: this.domainC[key].name,
                data: {
                  spinner: false,
                  success: false,
                  error: error.data.messages.errors
                }
              }
              DomainSearchResult.update({...d})
              console.log('CREATE RESPONSE ERROR:::', d)
            })

        }
        })
      },
    },
    created() {
      const x = UserConfigDefaults.mainKeys.map(el=>{
        this.domain_configuration[el]=this.$userConfig[el]
      })
    }
  }
</script>

<style scoped>
  .footer-summary {
    margin-left: 220px;
    z-index: 1000;
    padding: 20px;
    /*height: 85px;*/
    bottom: 11px;
    background: white;
    box-shadow: 0 -1px 5px rgba(0,0,0,.2);
  }
  .center{
    max-width: 800px;
    margin-right: auto;
    margin-left: auto;
    padding-left: auto;
    padding-right: auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/domain/create_domain/luma-create-domain.vue